import { noop } from "lodash";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  PreviewComponentByVariantsProps,
  PreviewComponents,
} from "../../../types";
import { Lines } from "../Lines";
import { installmentsVariant } from "./installmentsVariants";
import { subscriptionVariant } from "./subscription";

export const defaultVariant: PreviewComponents = [
  [Lines.HeaderLine, noop],
  [Lines.SubtotalLine, noop],
  [Lines.DiscountLine, noop],
  [Lines.TaxLine, noop],
];

export const componentsByVariants: PreviewComponentByVariantsProps<{
  subscription: PreviewComponents;
  installments: PreviewComponents;
}> = {
  default: {
    [paywallPriceTypes.subscription]: defaultVariant,
    [paywallPriceTypes.installments]: defaultVariant,
  },
  paywall_customization: {
    [paywallPriceTypes.subscription]: subscriptionVariant,
    [paywallPriceTypes.installments]: installmentsVariant,
  },
};
